import script from "./icons.vue?vue&type=script&setup=true&lang=js"
export * from "./icons.vue?vue&type=script&setup=true&lang=js"

import "./icons.vue?vue&type=style&index=0&id=2783f7e8&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2783f7e8"]])

export default __exports__